
import React from "react";
export function HeroSection() {
    return (
        <>
            <section className="hero">
                <div className="wrap">
                    <div className="hero-l">
                        <div className="eyebrow"><span className="sec-id">01</span>
                            <span classNameName="mono" style={{ color: "var(--muted)" }} > Distribution, rebuilt </span>
                        </div>
                        <h1>From<br /><em>Product</em><br />To everywhere.</h1>
                        <p className="lead">We launch, operate and grow brands across Australia's marketplaces, retail channels and
                            direct-to-consumer stores.</p>
                        <div className="metarow">
                            <div><b>Operating partner</b><s>Single point of accountability</s></div>
                            <div><b>Local ownership</b><s>Australian operating company</s></div>
                            <div><b>National capability</b><s>Home to outdoor - and beyond</s></div>
                        </div>
                        <div className="btnrow">

                            <a
                                className="btn"
                                href="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("partner")?.scrollIntoView({
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                Explore a partnership <span>→</span>
                            </a>

                            <a
                                className="btn ghost"
                                href="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById("model")?.scrollIntoView({
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                Live model <span>↓</span>
                            </a>
                        </div>
                    </div>

                    <div className="schem">
                        <div className="sc-cap"><span>Fig. 01 — channel schematic</span><span>One brand / all channels</span></div>
                        <div className="coords coords-t"><span>000</span><span>025</span><span>050</span><span>075</span><span>100</span>
                        </div>
                        <div className="coords coords-l"><span>A</span><span>B</span><span>C</span><span>D</span></div>
                        <span className="tickr t"></span><span className="tickr b"></span>
                        <span className="tickc l"></span><span className="tickc r"></span>
                        <div className="dg">
                            <svg className="wires" viewBox="0 0 600 600" preserveAspectRatio="none" aria-hidden="true">
                                <g>
                                    <path className="wire" d="M212 300 H 250 V 62 H 292" />
                                    <path className="wire" d="M212 300 H 292" />
                                    <path className="wire" d="M212 300 H 250 V 538 H 292" />
                                    <path className="pulse p1" d="M212 300 H 250 V 62 H 292" />
                                    <path className="pulse p2" d="M212 300 H 292" />
                                    <path className="pulse p3" d="M212 300 H 250 V 538 H 292" />
                                    <circle className="jn" cx="250" cy="62" r="2.6" />
                                    <circle className="jn" cx="250" cy="538" r="2.6" />
                                </g>
                            </svg>
                            <div className="hub">
                                <span className="hb-tag">Hub / h2o</span>
                                <b>H<sub>2</sub>O</b>
                                <span className="hb-rule"></span>
                                <small>One brand<br />All channels</small>
                                <span className="hb-st"><i></i>Operating</span>
                                <span className="hb-port p1"></span><span className="hb-port p2"></span><span className="hb-port p3"></span>
                            </div>
                            <div className="node a">
                                <div className="r1"><span className="n">01</span><span className="st">Node / mkt</span></div>
                                <span className="t">Marketplaces</span><span className="s">Apply / launch / manage</span>
                                <span className="bars">
                                    <i style={{ width: "86%" }}></i>

                                </span>
                            </div>
                            <div className="node b">
                                <div className="r1"><span className="n">02</span><span className="st">Node / ret</span></div>
                                <span className="t">Retail</span><span className="s">Reach / range / supply</span>
                                <span className="bars"><i style={{ width: "64%" }}></i>
                                </span>
                            </div>
                            <div className="node c">
                                <div className="r1"><span className="n">03</span><span className="st">Node / dir</span></div>
                                <span className="t">Direct</span><span className="s">Build / operate / grow</span>
                                <span className="bars"><i style={{ width: "73%" }}></i></span>
                            </div>
                        </div>
                        <div className="sc-foot"><span>Operating partner</span><span>Local ownership</span><span>National capability</span>
                        </div>
                    </div>
                </div>
                <div className="ticker">
                    <span className="lbl">Live <span className="dot"></span></span>
                    <div className="tk-track">
                        <ul>
                            <li>Market entry</li>
                            <li>Marketplace management</li>
                            <li>Retail distribution</li>
                            <li>Brand operations</li>
                            <li>Channel growth</li>
                            <li>Market entry</li>
                            <li>Marketplace management</li>
                            <li>Retail distribution</li>
                            <li>Brand operations</li>
                            <li>Channel growth</li>
                        </ul>
                    </div>
                </div>
            </section>
        </>







    );
}

